"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultGuardModel = void 0;
class DefaultGuardModel {
    constructor() {
        this.match = (request, policy) => {
            return (this.matchSubject(request.subject, policy.subject) &&
                this.matchResource(request.resource, policy.resource) &&
                this.matchAction(request.action, policy.action));
        };
    }
    matchSubject(requestSubject, policySubject) {
        return requestSubject.role === policySubject.role;
    }
    matchResource(requestResource, policyResource) {
        return requestResource.name === policyResource.name;
    }
    matchAction(requestAction, policyAction) {
        return requestAction.split(',').every((i) => policyAction.split(',').includes(i));
    }
    effect(request, policyList) {
        return policyList.some((policy) => this.match(request.toJS(), policy.toJS()));
    }
}
exports.DefaultGuardModel = DefaultGuardModel;
//# sourceMappingURL=DefaultGuardModel.js.map